module.exports = __webpack_public_path__ + "static/EnmTX_BosArchibold_M_A_cl-01831eeef5792778c0f3bff0b58d50da.gif";